import React from "react"
import { Typography, theme } from "cdh-data-portal-theme"
import { useStyles } from "./StatCard.style"
import type { StatCardProps } from "./StatCard.static"

export const StatCard: React.FC<StatCardProps> = ({ className, color, count, title }) => {
  const { classes, cx } = useStyles()

  return (
    <div className={cx(classes.root, className)}>
      <Typography variant="body" color={theme.textColors.primary}>{title}</Typography>
      <Typography variant="headline1" className={classes.count} color={color}>{count}</Typography>
    </div>
  )
}
